import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getRelationships(patientId, params) {
        return Axios.get(`${baseURL}patient/${patientId}/relationships`, {
            params
        }).then(response => response.data.response);
    },
    setAsPrimaryRelationship(patientId, params) {
        return Axios.post(
            `${baseURL}patient/${patientId}/assign-primary-relationship`,
            params
        ).then(response => response.data.response);
    },
    deleteRelationship(patientId, params) {
        return Axios.delete(`${baseURL}patient/${patientId}/relationship`, {
            params
        }).then(response => response.data.response);
    },
    getPatientRelationshipType() {
        return Axios.get(
            `${baseURL}reference/patient-relation-type?module=patient`
        ).then(response => response.data.response);
    },
    addRelationship(patientId, params) {
        return Axios.post(
            `${baseURL}patient/${patientId}/relationship`,
            params
        ).then(response => response.data.response);
    },
    updateRelationship(patientId, params) {
        return Axios.put(
            `${baseURL}patient/${patientId}/relationship`,
            params
        ).then(response => response.data.response);
    }
};
